import { useStaticQuery, graphql } from 'gatsby';
import DOMPurify from 'isomorphic-dompurify';

import '../../styles/hero-header.css';

import { _ } from '../../utils/l10n';

export const HeroHeader = () => {
  // @todo Investigate why properties are not recognized in the auto-generated type
  // @ts-ignore "Property childMdx does not exist on type..."
  const { file: { childMdx: { frontmatter: { hero } } } } : Queries.HomePageHeroQuery = useStaticQuery(graphql`
    query HomePageHero {
      file(
        sourceInstanceName: {eq: "content"}
        relativeDirectory: {eq: ""}
        name: {eq: "index"}
      ) { childMdx { frontmatter { hero { title body } } } }
    }
  `)

  const mainTitle = hero.title;
  const slogan = hero.body;

  return (
    <section className='hero-section'>
      <div className='homepage-title-top'>
        <div
          className='homepage-title-main'
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mainTitle)}}
        />
        <span className='slogan'>{slogan}</span>
      </div>
      <div className='hero-header'>
        <div className='image-container hero-image-container' />
        <div className='hero-header-info-right'>
          <div className='homepage-title'>
            <div
              className='homepage-title-main'
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mainTitle)}}
            />
            <span className='slogan'>{slogan}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
